import type { ReactNode } from "react";
import { CheckerThumb } from "../components/primitives";

export interface PageHeadProps {
  /** 목업 프레임 번호. PRD·이슈·코드 리뷰가 같은 화면을 가리키게 하는 **코드 안의 표지**다.
   *
   * ⛔ **화면에 그리지 않는다** (2026-10-04 사용자 지시). 제목 앞에 `W-20` 같은 번호가 서 있던
   * 동안 셀러와 결제사 심사자가 내부 설계 번호를 봤다. 셀러에게는 뜻이 없는 글자다.
   * `scripts/web-console-annotations.test.mjs` 가 콘솔 화면의 `className="fid"` 를 막는다. */
  frame: string;
  title: string;
  subtitle?: ReactNode;
  right?: ReactNode;
  /** 한 작업을 다루는 화면은 제목 앞에 그 작업의 썸네일을 둔다. */
  thumbSample?: string;
}

/** 제목과 설명을 줄표가 아니라 **마침표**로 끊는다. 줄표는 셀러 화면에서 쓰지 않는다 —
 *  문장 경계가 줄을 타면 어디까지가 이름이고 어디부터가 설명인지 읽히지 않는다. */
export function PageHead({ title, subtitle, right, thumbSample }: PageHeadProps) {
  return (
    <div className="head">
      <span className="jname">
        {thumbSample ? <CheckerThumb size={34} sample={thumbSample} /> : null}
        <span>
          <b className="paneltitle">{title}</b>
          {subtitle ? <>. {subtitle}</> : null}
        </span>
      </span>
      {right ? <span className="right mono">{right}</span> : null}
    </div>
  );
}
